'use es6';

import { Record, Map as ImmutableMap } from 'immutable';
export default Record({
  timestamp: 0,
  isFetching: false,
  result: ImmutableMap()
}, 'CacheResult');